var map = {
	"./img1_desk@2x.webp": 6622,
	"./img2_desk@2x.webp": 5059,
	"./img3_desk@2x.webp": 752,
	"./img4_desk@2x.webp": 7333,
	"./img5_desk@2x.webp": 9138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3587;